import { StanInput } from '@/components';
import { useStoreItem } from '@/features/theme-editor/hooks/useStoreItem';
import { TitleDataSchema } from '@/features/theme-editor/schema/store';
import { useCustomizationStore } from '@/features/theme-editor/stores/customizationStore';
import { TitleItem } from '@/features/theme-editor/types/store';
import z from 'zod';
import { Panel, PanelFooter } from '../../Panel';
import { Label } from '../../ui/Label';

interface Props {
    id: number;
}

const TitleDataEditSchema = TitleDataSchema.extend({
    title: z.string().optional(),
});

export const Title = ({ id }: Props) => {
    const item = useStoreItem(id);
    const { updateItem } = useCustomizationStore();

    const validation = TitleDataEditSchema.safeParse(item?.data);
    if (!item || !validation.success) {
        console.error('Title data validation failed:', validation.error);
        return null;
    }

    const data = validation.data;
    const { title } = data;
    const maxCount = 120;

    return (
        <Panel footer={<PanelFooter id={id} />}>
            <Label
                label='Section title'
                required
                currentCount={title?.length?.toString() ?? '0'}
                totalCount={maxCount.toString()}
            >
                <StanInput
                    name='title'
                    placeholder='Section Title'
                    onChange={event => {
                        const value = event.target.value.slice(0, maxCount);
                        updateItem({
                            ...item,
                            data: { ...data, title: value },
                        } as TitleItem);
                    }}
                    value={title ?? ''}
                />
            </Label>
        </Panel>
    );
};
